<template>
  <div class="receive-code-page" :class="{ 'no-scroll': isAnyDialogOpen }">
    <!-- 桌面端布局 -->
    <div class="desktop-layout" v-if="!isMobile">
      <div class="container">
        <!-- 上半部分 -->
        <div class="top-section">
          <div class="top-grid">
            <!-- 余额和操作区域 -->
            <div class="balance-section">
              <div class="card h-full">
                <div class="card-header">
                  <h3>
                    {{ $t('balance.title') }}
                    <div class="balance-tooltip tooltip-bottom">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="help-icon">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                        <path d="m9,9a3,3 0 1,1 6,0c0,2 -3,3 -3,3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="m12,17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="tooltip-content">
                        <p class="heading">{{ $t('account.balanceInsufficientTitle') }}</p>
                        <p>{{ $t('account.balanceInsufficientDesc') }}</p>
                      </div>
                    </div>
                  </h3>
                </div>
                <div class="card-content">
                  <div class="balance-display">
                    <div class="balance-info">
                      <span class="balance-label">{{ $t('balance.current') }}</span>
                      <div class="balance-value-row">
                        <span class="balance-value">{{ userBalance.balances || '0.00' }}</span>
                        <button class="btn btn-primary btn-sm" @click="showRechargeDialog = true">
                          {{ $t('balance.recharge') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="success-rate-display">
                    <span class="rate-label">
                      {{ $t('balance.successRate') }}
                      <div class="balance-tooltip inline-tooltip">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="help-icon">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                          <path d="m9,9a3,3 0 1,1 6,0c0,2 -3,3 -3,3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="m12,17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="tooltip-content">
                          <p class="heading">{{ $t('project.codeReceptionTipTitle') }}</p>
                          <p>{{ $t('project.codeReceptionTips[0]') }}</p>
                          <p>{{ $t('project.codeReceptionTips[1]') }}</p>
                          <p>{{ $t('project.codeReceptionTips[2]') }}</p>
                          <p>{{ $t('project.codeReceptionTips[3]') }}</p>
                        </div>
                      </div>
                    </span>
                    <span class="rate-value">{{ successRateData.successRate || '0.00' }}%</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 项目搜索和获取临时号码区域 -->
            <div class="operation-section">
              <div class="card h-full">
                <div class="card-header">
                  <h3>
                    {{ $t('project.operationTitle') }}
                    <div class="balance-tooltip tooltip-bottom tooltip-wide">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="help-icon">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                        <path d="m9,9a3,3 0 1,1 6,0c0,2 -3,3 -3,3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="m12,17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="tooltip-content">
                        <p class="heading">{{ $t('project.operationGuideTitle') }}</p>
                        <p>{{ $t('project.operationGuides[0]') }}</p>
                        <p>{{ $t('project.operationGuides[1]') }}</p>
                        <p>{{ $t('project.operationGuides[2]') }}</p>
                        <p>{{ $t('project.operationGuides[3]') }}</p>
                        <p class="heading">{{ $t('project.smsTemplateIssueTitle') }}</p>
                        <p>{{ $t('project.smsTemplateIssues[0]') }}</p>
                        <p>{{ $t('project.smsTemplateIssues[1]') }}</p>
                        <p>{{ $t('project.smsTemplateIssues[2]') }}</p>
                        <p class="heading">{{ $t('project.newPhoneIssueTitle') }}</p>
                        <p>{{ $t('project.newPhoneIssue') }}</p>
                        <p class="heading">{{ $t('project.codeReceptionTipTitle') }}</p>
                        <p>{{ $t('project.codeReceptionTips[0]') }}</p>
                        <p>{{ $t('project.codeReceptionTips[1]') }}</p>
                        <p>{{ $t('project.codeReceptionTips[2]') }}</p>
                        <p>{{ $t('project.codeReceptionTips[3]') }}</p>
                      </div>
                    </div>
                  </h3>
                  <div class="header-buttons">
                    <button class="btn btn-sm btn-text" @click="goToInternationalProjects">
                      {{ $t('project.internationalProjectsButton') }}
                    </button>
                    <button v-if="!isMobile" class="btn btn-sm btn-text" @click="showTutorialMenu = true">
                      {{ $t('tutorial.menu.title') }}
                    </button>
                  </div>
                  <TutorialMenu
                    v-if="!isMobile"
                    :show="showTutorialMenu"
                    @close="showTutorialMenu = false"
                    @start-tutorial="handleStartTutorial"
                  />
                </div>
                <div class="card-content">
                  <!-- 项目搜索 -->
                  <div class="form-group">
                    <div class="input-with-button project-search-input">
                      <input
                        type="text"
                        v-model="searchKeyword"
                        :placeholder="$t('project.searchPlaceholder')"
                        class="form-input"
                        @keyup.enter="searchProjects(true)"
                      />
                      <button class="btn btn-primary" @click="searchProjects(true)">
                        {{ $t('project.searchButton') }}
                      </button>
                    </div>
                  </div>

                  <!-- 已选渠道信息 -->
                  <div v-if="selectedProject && selectedChannel" class="selected-info">
                    <div class="info-row">
                      <span class="info-label">{{ $t('project.channel') }}</span>
                      <span class="info-value">{{ selectedChannel.projectName }}</span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">{{ $t('project.price') }}</span>
                      <span class="info-value price">
                        <template v-if="hasActivity(selectedChannel)">
                          <span class="current-price">{{ getDisplayPrice(selectedChannel) }}</span>
                          <span class="original-price">{{ getOriginalPrice(selectedChannel) }}</span>
                          <span class="activity-tag">{{ getActivityName(selectedChannel) }}</span>
                        </template>
                        <template v-else>{{ getDisplayPrice(selectedChannel) }}</template>
                      </span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">{{ $t('project.connectionCode') }}</span>
                      <span class="info-value">{{ selectedChannel.code }}</span>
                    </div>
                    <div class="action-buttons quick-switch-section">
                      <button class="btn btn-sm btn-outline" @click="copyApiParams">
                        {{ $t('project.getApiParams') }}
                      </button>
                      <button class="btn btn-sm btn-outline" @click="openQuickChannelSelect" v-if="lastChannelList.length > 0">
                        {{ $t('project.switchChannel') }}
                      </button>
                    </div>
                  </div>

                  <!-- 高级选项 -->
                  <div class="advanced-toggle">
                    <button class="btn btn-text" @click="showAdvancedOptions = !showAdvancedOptions">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path :d="showAdvancedOptions ? 'M19 9l-7 7-7-7' : 'M9 5l7 7-7 7'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      {{ showAdvancedOptions ? $t('advancedOptions.collapse') : $t('advancedOptions.expand') }}
                    </button>
                  </div>

                  <div v-if="showAdvancedOptions" class="advanced-options">
                    <div class="form-group">
                      <label>{{ $t('advancedOptions.cardType') }}</label>
                      <select v-model="advancedOptions.cardType" class="form-select">
                        <option value="">{{ $t('advancedOptions.cardTypeOptions.unlimited') }}</option>
                        <option value="4">{{ $t('advancedOptions.cardTypeOptions.physical') }}</option>
                        <option value="5">{{ $t('advancedOptions.cardTypeOptions.virtual') }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>{{ $t('advancedOptions.specificPhone') }}</label>
                      <input type="text" v-model="advancedOptions.phone" class="form-input" :placeholder="$t('common.optional')" />
                    </div>
                    <div class="form-group">
                      <label>{{ $t('advancedOptions.includePrefix') }}</label>
                      <input type="text" v-model="advancedOptions.includePrefix" class="form-input" :placeholder="$t('advancedOptions.includePrefixPlaceholder')" />
                    </div>
                    <div class="form-group">
                      <label>{{ $t('advancedOptions.excludePrefix') }}</label>
                      <input type="text" v-model="advancedOptions.excludePrefix" class="form-input" :placeholder="$t('advancedOptions.excludePrefixPlaceholder')" />
                    </div>
                    <div class="form-group">
                      <label>{{ $t('advancedOptions.province') }}</label>
                      <input type="text" v-model="advancedOptions.address" class="form-input" :placeholder="$t('advancedOptions.provincePlaceholder')" />
                    </div>
                  </div>

                  <!-- 获取临时号码按钮 -->
                  <div class="form-actions">
                    <button
                      class="btn btn-primary btn-large get-number-btn"
                      @click="getPhoneNumber"
                      :disabled="!selectedChannel || gettingPhone"
                    >
                      <span v-if="gettingPhone" class="btn-spinner"></span>
                      {{ gettingPhone ? $t('advancedOptions.getPhoneLoading') : $t('advancedOptions.getPhoneButton') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 下半部分 - 临时号码表格 -->
        <div class="phone-number-section">
          <PhoneNumberList
            :phone-list="phoneList"
            :release-loading="releaseLoading"
            :blacklist-loading="blacklistLoading"
            :enable-audio="enableAudio"
            :auto-save-data="autoSaveData"
            :is-mobile="false"
            @release-phone="releasePhone"
            @add-blacklist="addToBlacklist"
            @release-all="releaseAllPhones"
            @copy-all="copyAllPhoneNumbers"
            @toggle-audio="enableAudio = !enableAudio"
            @update:auto-save-data="autoSaveData = $event"
          />
        </div>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div class="mobile-layout" v-else>
      <!-- 头部状态栏 -->
      <div class="mobile-header">
        <div class="mobile-status-bar">
          <div class="status-item balance-section">
            <div class="status-label">{{ $t('mobile.header.balance') }}</div>
            <div class="balance-row">
              <div class="status-value">{{ userBalance.balances || '0.00' }}</div>
              <button class="recharge-btn" @click="showRechargeDialog = true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2v20M2 12h20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                {{ $t('mobile.header.recharge') }}
              </button>
            </div>
          </div>
          <div class="status-item">
            <div class="status-label">{{ $t('mobile.channelList.successRate') }}</div>
            <div class="status-value">{{ successRateData.successRate || '0' }}%</div>
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="mobile-content">
        <!-- 项目搜索卡片 -->
        <div class="mobile-search-section">
          <div class="mobile-section-header">
            <h3 class="mobile-section-title">{{ $t('project.searchProject') }}</h3>
            <button class="mobile-link-btn" @click="goToInternationalProjects">
              <span>{{ $t('project.internationalProjects') }}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          
          <div class="mobile-search-container">
            <div class="mobile-search-field">
              <input 
                type="text"
                v-model="searchKeyword" 
                :placeholder="$t('project.searchPlaceholder')"
                class="mobile-search-input"
                @keyup.enter="searchProjects(true)"
              />
              <button class="mobile-search-action" @click="openProjectSearch(true)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
                  <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- 已选渠道信息卡片 -->
        <div v-if="selectedProject && selectedChannel" class="mobile-card selected-channel-card">
          <div class="mobile-card-header">
            <div class="mobile-card-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 16V8A2 2 0 0 0 19 6H5A2 2 0 0 0 3 8V16A2 2 0 0 0 5 18H19A2 2 0 0 0 21 16Z" stroke="currentColor" stroke-width="2"/>
                <path d="M7 10H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M7 14H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              {{ $t('project.currentChannel') }}
            </div>
          </div>
          <div class="mobile-card-body">
            <div class="channel-info">
              <div class="channel-info-row">
                <span class="channel-info-label">{{ $t('project.project') }}</span>
                <span class="channel-info-value">{{ selectedChannel.projectName }}</span>
              </div>
              <div class="channel-info-row">
                <span class="channel-info-label">{{ $t('mobile.channelList.price') }}</span>
                <span class="channel-info-value activity-price-display">
                  <template v-if="hasActivity(selectedChannel)">
                    <span class="current-price">{{ getDisplayPrice(selectedChannel) }}</span>
                    <span class="original-price">{{ getOriginalPrice(selectedChannel) }}</span>
                    <span class="activity-tag">{{ getActivityName(selectedChannel) }}</span>
                  </template>
                  <template v-else>{{ getDisplayPrice(selectedChannel) }}</template>
                </span>
              </div>
              <div class="channel-info-row">
                <span class="channel-info-label">{{ $t('project.channelCode') }}</span>
                <span class="channel-info-value">{{ selectedChannel.code }}</span>
              </div>
              <div class="channel-info-row" v-if="selectedChannel.numberSegment">
                <span class="channel-info-label">{{ $t('project.numberSegment') }}</span>
                <span class="channel-info-value">{{ selectedChannel.numberSegment }}</span>
              </div>
              <div class="channel-info-row" v-if="selectedChannel.content">
                <span class="channel-info-label">{{ $t('phoneList.status.label') }}</span>
                <span class="channel-info-value">{{ selectedChannel.content }}</span>
              </div>
            </div>
            <div class="channel-actions">
              <button class="channel-action-btn" @click="copyApiParams">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
                </svg>
                {{ $t('project.copyAPI') }}
              </button>
              <button class="channel-action-btn" @click="openQuickChannelSelect" v-if="lastChannelList.length > 0">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M3 12A9 9 0 0 1 12 3A9 9 0 0 1 21 12A9 9 0 0 1 12 21A9 9 0 0 1 3 12Z" stroke="currentColor" stroke-width="2"/>
                  <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ $t('project.switch') }}
              </button>
            </div>
          </div>
        </div>

        <!-- 高级选项折叠面板 -->
        <div class="mobile-accordion">
          <div class="mobile-accordion-header" @click="showAdvancedOptions = !showAdvancedOptions">
            <div class="mobile-accordion-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                <path d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{ $t('advancedOptions.title') }}
            </div>
            <svg class="accordion-icon" :class="{ 'rotated': showAdvancedOptions }" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M19 9l-7 7-7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div v-if="showAdvancedOptions" class="mobile-accordion-content">
            <div class="mobile-form-group">
              <label>{{ $t('advancedOptions.cardType') }}</label>
              <select v-model="advancedOptions.cardType" class="mobile-form-select">
                <option value="">{{ $t('advancedOptions.cardTypeOptions.unlimited') }}</option>
                <option value="4">{{ $t('advancedOptions.cardTypeOptions.physical') }}</option>
                <option value="5">{{ $t('advancedOptions.cardTypeOptions.virtual') }}</option>
              </select>
            </div>
            <div class="mobile-form-group">
              <label>{{ $t('advancedOptions.specificPhone') }}</label>
              <input type="text" v-model="advancedOptions.phone" class="mobile-form-input" :placeholder="$t('common.optional')" />
            </div>
            <div class="mobile-form-group">
              <label>{{ $t('advancedOptions.includePrefix') }}</label>
              <input type="text" v-model="advancedOptions.includePrefix" class="mobile-form-input" :placeholder="$t('advancedOptions.includePrefixPlaceholder')" />
            </div>
            <div class="mobile-form-group">
              <label>{{ $t('advancedOptions.excludePrefix') }}</label>
              <input type="text" v-model="advancedOptions.excludePrefix" class="mobile-form-input" :placeholder="$t('advancedOptions.excludePrefixPlaceholder')" />
            </div>
            <div class="mobile-form-group">
              <label>{{ $t('advancedOptions.province') }}</label>
              <input type="text" v-model="advancedOptions.address" class="mobile-form-input" :placeholder="$t('advancedOptions.provincePlaceholder')" />
            </div>
          </div>
        </div>

        <!-- 临时号码列表 -->
        <PhoneNumberList
          :phone-list="phoneList"
          :release-loading="releaseLoading"
          :blacklist-loading="blacklistLoading"
          :enable-audio="enableAudio"
          :auto-save-data="autoSaveData"
          :is-mobile="true"
          @release-phone="releasePhone"
          @add-blacklist="addToBlacklist"
          @release-all="releaseAllPhones"
          @copy-all="copyAllPhoneNumbers"
          @toggle-audio="enableAudio = !enableAudio"
          @update:auto-save-data="autoSaveData = $event"
        />
      </div>

      <!-- 底部固定操作区域 -->
      <div class="mobile-action-area">
        <button 
          class="mobile-get-btn"
          @click="getPhoneNumber"
          :disabled="!selectedChannel || gettingPhone"
        >
          <span v-if="gettingPhone" class="btn-spinner"></span>
          <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
          </svg>
          {{ gettingPhone ? $t('phoneList.gettingPhone') : $t('phoneList.getPhone') }}
        </button>
      </div>
    </div>

    <!-- 组件：充值弹窗 -->
    <RechargeDialog
      ref="rechargeDialogRef"
      :show="showRechargeDialog"
      :recharge-type="rechargeType"
      :transaction-info="transactionInfo"
      :recharge-log="rechargeLog"
      :card-loading="cardActivationLoading"
      @close="showRechargeDialog = false"
      @type-change="handleRechargeTypeChange"
      @card-recharge="handleCardActivation"
      @usdt-amount-change="handleCalcPrice"
    />

    <!-- 组件：项目列表 -->
    <div class="project-list-container">
      <ProjectList
        :show="showProjectDialog"
        :project-list="projectResults"
        :loading="searchLoading"
        :searched="hasSearched"
        @close="showProjectDialog = false"
        @select-project="handleProjectSelect"
        @show-channels="showChannels"
        @apply-project="openApplyProjectForm"
      />
    </div>

    <!-- 组件：渠道列表 -->
    <div class="channel-list-container">
      <ChannelList
        :show="showChannelDialog"
        :show-quick-select="showQuickChannelSelect"
        :channel-list="channelList"
        :quick-channel-list="lastChannelList"
        :selected-channel="selectedChannel"
        :loading="channelLoading"
        :select-loading="channelSelectLoading"
        :supplier="selectedProject?.supplier"
        @close="showChannelDialog = false"
        @close-quick="showQuickChannelSelect = false"
        @select-channel="selectChannel"
        @quick-select="selectQuickChannel"
        @country-change="handleCountryChange"
      />
    </div>

    <!-- 申请项目弹窗 -->
    <div v-if="showApplyProjectDialog" class="dialog-overlay" @click="showApplyProjectDialog = false">
      <div class="dialog" @click.stop>
        <div class="dialog-header">
          <h3>{{ $t('applyProject.title') }}</h3>
          <button class="close-btn" @click="showApplyProjectDialog = false">×</button>
        </div>
        <div class="dialog-content">
          <div class="form-tip">
            <p>{{ $t('applyProject.contentExample') }}</p>
          </div>
          <div class="form-group">
            <label>{{ $t('applyProject.smsExample') }}</label>
            <textarea 
              v-model="applyProjectForm.content" 
              class="form-textarea"
              :placeholder="$t('projectApplication.smsContentPlaceholder')"
              rows="4"
            ></textarea>
          </div>
          <div class="form-actions">
            <button 
              class="btn btn-primary" 
              @click="submitApplyProject"
              :disabled="applyProjectLoading"
            >
              <span v-if="applyProjectLoading" class="btn-spinner"></span>
              {{ $t('applyProject.submitButton') }}
            </button>
            <button class="btn btn-outline" @click="showApplyProjectDialog = false">{{ $t('common.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 公告弹窗 -->
    <div v-if="showNoticeDialog" class="dialog-overlay" @click="closeNoticeDialog">
      <div class="dialog" @click.stop>
        <div class="dialog-header">
          <h3>{{ $t('notice.title') }}</h3>
          <button class="close-btn" @click="closeNoticeDialog">×</button>
        </div>
        <div class="dialog-content">
          <div class="notice-content">
            {{ noticeContent }}
          </div>
          <div class="notice-countdown">
            {{ $t('notice.autoCloseIn', { seconds: noticeCountdown }) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 新手引导教程组件 -->
    <Tutorial
      v-if="!isMobile"
      :active="tutorial.isActive.value"
      :steps="tutorial.steps.value"
      :current-step="tutorial.currentStepIndex.value"
      @next="tutorial.nextStep"
      @prev="tutorial.prevStep"
      @skip="tutorial.skipTutorial"
      @finish="tutorial.finishTutorial"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import api from '@/api'
import { showErrorIfNotNotified } from '@/api/http'
import { isAuthenticated } from '@/api/user'

// 导入模块化组件
import { ProjectList, ChannelList, RechargeDialog, PhoneNumberList } from '@/components/ReceiveCode'

// 导入教程相关
import Tutorial from '@/components/common/Tutorial.vue'
import TutorialMenu from '@/components/common/TutorialMenu.vue'
import { useTutorial } from '@/utils/useTutorial'
import { TUTORIAL_TYPES } from '@/data/tutorialConfig'

export default {
  name: 'ReceiveCodeView',
  components: {
    ProjectList,
    ChannelList,
    RechargeDialog,
    PhoneNumberList,
    Tutorial,
    TutorialMenu
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { t: $t } = useI18n()

    // 初始化教程
    const tutorial = useTutorial(TUTORIAL_TYPES.RECEIVE_CODE)

    // 检测是否移动端 - 添加响应式窗口大小检测
    const windowWidth = ref(window.innerWidth)
    const isMobile = computed(() => {
      return windowWidth.value <= 768
    })
    
    // 检测是否有任何对话框打开
    const isAnyDialogOpen = computed(() => {
      return showRechargeDialog.value || 
             showProjectDialog.value || 
             showChannelDialog.value || 
             showQuickChannelSelect.value || 
             showApplyProjectDialog.value || 
             showNoticeDialog.value
    })
    
    // 防抖处理窗口大小变化
    let resizeTimer = null
    const handleResize = () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        windowWidth.value = window.innerWidth
      }, 100)
    }
    
    // 响应式数据
    const userBalance = ref({ balances: '0.00' })
    const successRateData = ref({ successRate: '0.00' })
    const searchKeyword = ref('')
    const selectedProject = ref(null)
    const selectedChannel = ref(null)
    const phoneList = ref([])
    const gettingPhone = ref(false)
    const enableAudio = ref(false)

    // 弹窗状态
    const showRechargeDialog = ref(false)
    const rechargeDialogRef = ref(null)
    const showProjectDialog = ref(false)
    const showChannelDialog = ref(false)
    const showAdvancedOptions = ref(false)
    const showQuickChannelSelect = ref(false)
    const showNoticeDialog = ref(false)
    const showApplyProjectDialog = ref(false)
    const showTutorialMenu = ref(false)
    
    // 充值相关
    const rechargeType = ref('easypay')
    const cardNumber = ref('')
    const usdtAmount = ref('')
    const cardActivationLoading = ref(false)
    const transactionInfo = ref({
      address: '',
      price: null,
      usdtMoney: null,
      id: null,
    })
    const rechargeLog = ref('')
    const checkingRecharge = ref(false)
    const autoCheckTimer = ref(null)
    
    // 项目和渠道
    const projectResults = ref([])
    const channelList = ref([])
    const lastChannelList = ref([])
    const searchLoading = ref(false)
    const channelLoading = ref(false)
    const channelSelectLoading = ref(false)
    const hasSearched = ref(false)
    const selectedCountryCode = ref('') // 国家筛选（用于supplier=14）

    // 高级选项
    const advancedOptions = ref({
      cardType: '',
      phone: '',
      includePrefix: '',
      excludePrefix: '',
      address: ''
    })
    
    // 轮询相关
    const pollingTimers = ref({})
    const releaseLoading = ref(new Set())
    const blacklistLoading = ref(new Set())
    const autoSaveData = ref(false)
    const autoSavedPhoneIds = new Set()
    
    // 公告相关
    const noticeContent = ref('')
    const noticeCountdown = ref(10)
    const noticeTimer = ref(null)
    
    // 申请项目
    const applyProjectForm = ref({
      content: ''
    })
    const applyProjectLoading = ref(false)
    
    // 检查认证
    const checkAuth = () => {
      if (!isAuthenticated()) {
        ElMessage.warning($t('messages.loginRequired'))
        router.push('/login')
        return false
      }
      return true
    }
    
    // 获取用户余额
    const fetchUserBalance = async () => {
      if (!checkAuth()) return
      
      try {
        const response = await api.getUserBalance()
        if (response.success && response.data) {
          userBalance.value = response.data
        }
      } catch (error) {
        console.error('获取余额失败:', error)
      }
    }
    
    // 获取用户成功率
    const fetchSuccessRate = async () => {
      if (!checkAuth()) return
      
      try {
        const response = await api.getSuccessRate()
        if (response.success && response.data) {
          successRateData.value = response.data
        }
      } catch (error) {
        console.error('获取成功率失败:', error)
      }
    }
    
    // 搜索项目
    const searchProjects = async (openDialog = false) => {
      if (!checkAuth()) return
      
      if (!searchKeyword.value.trim()) {
        if (openDialog) {
          showProjectDialog.value = true
        }
        return
      }
      
      searchLoading.value = true
      hasSearched.value = true
      
      if (openDialog) {
        showProjectDialog.value = true
      }
      
      try {
        const response = await api.searchProjects(searchKeyword.value)
        if ((response.code === 200 || response.status === 200 || response.success) && response.data) {
          // 处理嵌套数据结构
          projectResults.value = response.data.list || []
          hasSearched.value = true
          
          if (projectResults.value.length === 0) {
            ElMessage.info($t('projectSearch.noResults'))
          }
        } else {
          projectResults.value = []
          hasSearched.value = true
          ElMessage.error(response.msg || $t('messages.searchFailed'))
        }
      } catch (error) {
        console.error('搜索项目失败:', error)
        projectResults.value = []
        showErrorIfNotNotified(error, $t('messages.searchFailed'))
      } finally {
        searchLoading.value = false
      }
    }
    
    // 打开项目搜索弹窗
    const openProjectSearch = (shouldSearch = false) => {
      showProjectDialog.value = true
      if (shouldSearch && searchKeyword.value.trim()) {
        searchProjects(false)
      }
    }
    
    // 选择项目
    const handleProjectSelect = (project) => {
      selectedProject.value = project
      selectedChannel.value = null
      showProjectDialog.value = false
      // 项目选择后清除之前的渠道选择缓存
      localStorage.removeItem('channel-selection')
    }
    
    // 显示渠道列表
    const showChannels = async (projectId, projectSid) => {
      if (!checkAuth()) return

      try {
        channelLoading.value = true
        showChannelDialog.value = true

        // 从项目结果中找到对应的项目
        const project = projectResults.value.find(p =>
          p.id === projectId && (projectSid ? p.sid === projectSid : !p.sid)
        )

        if (!project || !project.channelIdList) {
          ElMessage.warning($t('messages.channelInfoNotFound'))
          return
        }

        selectedProject.value = project

        // 构造请求参数
        const params = {
          keyword: projectId,
          channelIdList: project.channelIdList,
          priceSort: false
        }

        // 如果supplier=14且选择了国家，添加countryCode参数
        if ((project.supplier === 14 || project.supplier === '14') && selectedCountryCode.value) {
          params.countryCode = selectedCountryCode.value
        }

        channelList.value = []
        const response = await api.getProjectChannels(params)

        if ((response.code === 200 || response.status === 200) && response.data) {
          // 根据API响应格式，数据在 response.data.data.list 或 response.data.list
          channelList.value = response.data?.data?.list || response.data?.list || []
          // 缓存最后一次获取的渠道列表
          lastChannelList.value = [...channelList.value]

          if (channelList.value.length === 0) {
            ElMessage.info($t('channelSelection.noChannels'))
          }
        } else {
          channelList.value = []
          ElMessage.error(response.msg || $t('messages.getChannelsFailed'))
        }
      } catch (error) {
        console.error('获取渠道失败:', error)
        channelList.value = []
        showErrorIfNotNotified(error, $t('messages.getChannelsFailed'))
      } finally {
        channelLoading.value = false
      }
    }

    // 处理国家筛选变化
    const handleCountryChange = async (countryCode) => {
      selectedCountryCode.value = countryCode

      // 如果当前有选中的项目，重新获取渠道列表
      if (selectedProject.value) {
        await showChannels(selectedProject.value.id, selectedProject.value.sid)
      }
    }

    // 选择渠道
    const selectChannel = async (channel) => {
      if (channelSelectLoading.value) return
      
      channelSelectLoading.value = true
      
      try {
        // 直接传递整个channel对象给API
        const response = await api.addChannelConnection(channel)
        
        if ((response.code === 200 || response.status === 200 || response.success) && response.data) {
          // 对接成功后更新选中的渠道
          selectedChannel.value = {
            ...channel,
            channelId: response.data.channelId || channel.channelId
          }
          
          // 更新选中的项目信息
          if (selectedProject.value) {
            selectedProject.value = {
              ...selectedProject.value,
              id: channel.projectId,
              name: channel.projectName,
              price: channel.price || channel.userMoney
            }
          }
          
          showChannelDialog.value = false
          showProjectDialog.value = false  // Also close project dialog
          ElMessage.success(response.data?.desc || $t('messages.channelSelected'))
          
          // 保存渠道选择到localStorage
          localStorage.setItem('channel-selection', JSON.stringify({
            channel: selectedChannel.value,
            project: selectedProject.value,
            lastChannelList: lastChannelList.value,
            timestamp: Date.now()
          }))
        } else {
          ElMessage.error(response.msg || $t('messages.selectChannelFailed'))
        }
      } catch (error) {
        console.error('选择渠道失败:', error)
        showErrorIfNotNotified(error, error.message || $t('messages.selectChannelFailed'))
      } finally {
        channelSelectLoading.value = false
      }
    }
    
    // 快速选择渠道
    const selectQuickChannel = async (channel) => {
      if (channelSelectLoading.value) return
      
      channelSelectLoading.value = true
      
      try {
        // 直接传递整个channel对象给API
        const response = await api.addChannelConnection(channel)
        
        if ((response.code === 200 || response.status === 200 || response.success) && response.data) {
          // 对接成功后更新选中的渠道
          selectedChannel.value = {
            ...channel,
            channelId: response.data.channelId || channel.channelId
          }
          
          // 更新选中的项目信息
          if (channel.projectId && channel.projectName) {
            selectedProject.value = {
              id: channel.projectId,
              name: channel.projectName,
              price: channel.price || channel.userMoney
            }
          }
          
          showQuickChannelSelect.value = false
          showProjectDialog.value = false  // Also close project dialog if open
          ElMessage.success(response.data?.desc || $t('messages.channelSelected'))
          
          // 保存渠道选择到localStorage
          localStorage.setItem('channel-selection', JSON.stringify({
            channel: selectedChannel.value,
            project: selectedProject.value,
            lastChannelList: lastChannelList.value,
            timestamp: Date.now()
          }))
        } else {
          ElMessage.error(response.msg || $t('messages.selectChannelFailed'))
        }
      } catch (error) {
        console.error('选择渠道失败:', error)
        showErrorIfNotNotified(error, error.message || $t('messages.selectChannelFailed'))
      } finally {
        channelSelectLoading.value = false
      }
    }
    
    // 打开快捷选择渠道弹窗
    const openQuickChannelSelect = () => {
      if (lastChannelList.value.length > 0) {
        showQuickChannelSelect.value = true
      } else {
        ElMessage.info($t('quickChannelSwitch.noChannelsInstruction'))
      }
    }

    // 将后端任务数据转换为前端 phoneList 格式
    const convertTaskToPhoneData = (task) => {
      return {
        id: Date.now() + Math.random(), // 前端唯一ID
        taskId: task.id,                 // 后端任务ID
        phoneNumber: task.phoneNo,
        location: '--',                  // 暂时用默认值
        operator: '--',                  // 暂时用默认值
        projectId: task.projectId,
        projectName: task.projectName,
        channelId: task.bizSmsProjectDetailInfo?.channelId || '',
        channelCode: task.bizSmsProjectDetailInfo?.code || '',
        status: 'waiting',
        remainingTries: Math.max(0, Math.floor(task.leftSeconds || 0)),
        verificationCode: '',
        smsContent: '',
        lastGetTime: null,
        createTime: task.createTime ? new Date(task.createTime) : new Date(),
        userMoney: task.userMoney,
        originalUserMoney: task.originalUserMoney,
        discountUserMoney: task.discountUserMoney,
        discountAmount: task.discountAmount,
        discountActivityId: task.discountActivityId,
        discountActivityName: task.discountActivityName
      }
    }

    // 加载进行中的任务
    const loadExistingTasks = async () => {
      if (!checkAuth()) return

      try {
        const response = await api.getTask()

        if ((response.code === 200 || response.status === 200 || response.success) && response.data) {
          const tasks = Array.isArray(response.data) ? response.data : []

          if (tasks.length === 0) {
            return
          }

          // 获取当前已有的临时号码列表
          const existingPhones = new Set(phoneList.value.map(p => p.phoneNumber))

          // 只添加不存在的任务
          tasks.forEach(task => {
            if (!existingPhones.has(task.phoneNo)) {
              const phoneData = convertTaskToPhoneData(task)
              phoneList.value.unshift(phoneData)

              // 启动轮询
              startPolling(phoneData)
            }
          })

          if (tasks.length > 0) {
            ElMessage.success($t('messages.tasksRestored', { count: tasks.length }))
          }
        }
      } catch (error) {
        console.error('加载进行中的任务失败:', error)
        // 静默失败，不影响用户体验
      }
    }
    
    const hasValue = (value) => value !== undefined && value !== null && value !== ''
    const pickValue = (...values) => values.find(hasValue)
    const formatPhoneLocation = (data) => {
      return [data?.province, data?.city, data?.sp].filter(hasValue).join('-') || '--'
    }
    const hasActivity = (row) => {
      const discountAmount = Number(row?.discountAmount)
      const hasPositiveDiscount = !Number.isNaN(discountAmount) && discountAmount > 0
      const hasDiscountPrice = hasValue(row?.discountUserMoney) && hasValue(row?.originalUserMoney) && String(row.discountUserMoney) !== String(row.originalUserMoney)
      return Boolean(row?.hasDiscountActivity || row?.discountActivityId || hasPositiveDiscount || hasDiscountPrice)
    }
    const getDisplayPrice = (row) => hasValue(row?.discountUserMoney) ? row.discountUserMoney : row?.userMoney
    const getOriginalPrice = (row) => hasValue(row?.originalUserMoney) ? row.originalUserMoney : row?.userMoney
    const getActivityName = (row) => row?.discountActivityName || $t('activity.active')

    // 获取临时号码
    const getPhoneNumber = async () => {
      if (!checkAuth()) return
      
      if (!selectedProject.value) {
        ElMessage.warning($t('messages.projectSelectionRequired'))
        return
      }
      
      if (!selectedChannel.value) {
        ElMessage.warning($t('messages.channelSelectionRequired'))
        return
      }
      
      gettingPhone.value = true
      
      try {
        // 构建请求参数，包含高级选项
        const params = {
          projectName: `${selectedProject.value.name}----金币：${getDisplayPrice(selectedChannel.value)}----可用：${selectedChannel.value.content}----channelId:${selectedChannel.value.channelId || ''}`,
          code: selectedChannel.value.code,
          channelId: selectedChannel.value.channelId || '',
          operator: advancedOptions.value.cardType || "0",
          phone_num: advancedOptions.value.phone || "",
          scope: advancedOptions.value.includePrefix || "",
          scope_black: advancedOptions.value.excludePrefix || "",
          projectId: null,
          address: advancedOptions.value.address || ""
        }
        
        const response = await api.getProjectPhone(params)
        if ((response.code === 200 || response.status === 200 || response.success) && response.data) {
          const phoneData = {
            id: Date.now(),
            taskId: response.data.smsTask?.id || response.data.id,
            phoneNumber: response.data.mobile || response.data.phoneNumber,
            location: formatPhoneLocation(response.data),
            operator: response.data.sp || '',
            projectId: response.data.smsTask?.projectId || selectedProject.value.id,
            projectName: selectedProject.value.name,
            channelId: selectedChannel.value.channelId || '',
            channelCode: selectedChannel.value.code,
            status: 'waiting',
            remainingTries: 60,
            verificationCode: '',
            smsContent: '',
            lastGetTime: null,
            createTime: new Date(),
            userMoney: pickValue(response.data.userMoney, response.data.smsTask?.userMoney, getDisplayPrice(selectedChannel.value)),
            originalUserMoney: pickValue(response.data.originalUserMoney, response.data.smsTask?.originalUserMoney, getOriginalPrice(selectedChannel.value)),
            discountUserMoney: pickValue(response.data.discountUserMoney, response.data.smsTask?.discountUserMoney, selectedChannel.value.discountUserMoney),
            discountAmount: pickValue(response.data.discountAmount, response.data.smsTask?.discountAmount, selectedChannel.value.discountAmount),
            discountActivityId: pickValue(response.data.discountActivityId, response.data.smsTask?.discountActivityId, selectedChannel.value.discountActivityId),
            discountActivityName: pickValue(response.data.discountActivityName, response.data.smsTask?.discountActivityName, selectedChannel.value.discountActivityName)
          }
          
          // 添加到列表前面
          phoneList.value.unshift(phoneData)
          
          // 开始轮询共享数据
          startPolling(phoneData)
          
          ElMessage.success($t('messages.phoneNumberSuccess'))
        } else {
          ElMessage.error(response.msg || $t('console.getPhoneFailed'))
        }
      } catch (error) {
        console.error('获取临时号码失败:', error)
        showErrorIfNotNotified(error, $t('console.getPhoneFailed'))
      } finally {
        gettingPhone.value = false
      }
    }
    
    // 开始轮询共享数据
    const downloadVerificationCode = (phoneNumber, verificationCode) => {
      const currentDate = new Date()
      const date = [
        currentDate.getFullYear(),
        String(currentDate.getMonth() + 1).padStart(2, '0'),
        String(currentDate.getDate()).padStart(2, '0')
      ].join('')
      const content = `${phoneNumber}-${date}-${verificationCode}`
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      const downloadUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = downloadUrl
      link.download = `${content}.txt`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(downloadUrl)
    }

    const startPolling = (phoneData) => {
      let tries = 0
      const maxTries = 60
      phoneData.remainingTries = maxTries
      
      const timer = setInterval(async () => {
        try {
          // 请求一次，倒计时减1
          tries += 1
          
          // 使用数组索引方式更新，确保触发响应式更新
          const index = phoneList.value.findIndex(p => p.id === phoneData.id)
          if (index !== -1) {
            // 创建一个新对象，保留原有属性并更新remainingTries
            const updatedPhone = { ...phoneList.value[index], remainingTries: maxTries - tries }
            // 替换原对象，触发响应式更新
            phoneList.value.splice(index, 1, updatedPhone)
          }
          
          const params = {
            code: phoneData.channelCode,
            phoneNum: phoneData.phoneNumber,
            channelId: phoneData.channelId,
            projectId: null,
            phoneId: null
          }
          
          const response = await api.getPhoneVerificationCode(params)

          // 每次API调用后都更新lastGetTime，无论是否收到共享数据
          const phoneIndex = phoneList.value.findIndex(p => p.id === phoneData.id)
          if (phoneIndex !== -1) {
            const updatedPhone = {
              ...phoneList.value[phoneIndex],
              lastGetTime: response.data?.lastGetTime || '--'
            }

            // 如果收到共享数据，则同时更新共享数据和状态
            if ((response.code === 200 || response.status === 200 || response.success) && response.data && response.data.code) {
              updatedPhone.verificationCode = response.data.code
              updatedPhone.smsContent = response.data.modle || response.data.message || ''
              updatedPhone.status = 'received'

              if (autoSaveData.value && !autoSavedPhoneIds.has(phoneData.id)) {
                downloadVerificationCode(phoneData.phoneNumber, response.data.code)
                autoSavedPhoneIds.add(phoneData.id)
              }
            }

            phoneList.value.splice(phoneIndex, 1, updatedPhone)
          }

          if ((response.code === 200 || response.status === 200 || response.success) && response.data && response.data.code) {
              // 清除定时器
              clearInterval(timer)
              if (pollingTimers.value[phoneData.id]) {
                clearInterval(pollingTimers.value[phoneData.id])
                delete pollingTimers.value[phoneData.id]
              }

              ElMessage.success($t('messages.codeReceived'))

              // 播放提示音
              if (enableAudio.value) {
                playNotificationSound()
              }
          } else if (tries >= maxTries) {
            // 超时处理
            const index = phoneList.value.findIndex(p => p.id === phoneData.id)
            if (index !== -1) {
              const updatedPhone = { ...phoneList.value[index], status: 'timeout', remainingTries: 0 }
              phoneList.value.splice(index, 1, updatedPhone)
            }
            
            clearInterval(timer)
            if (pollingTimers.value[phoneData.id]) {
              clearInterval(pollingTimers.value[phoneData.id])
              delete pollingTimers.value[phoneData.id]
            }
            
            ElMessage.warning($t('messages.getCodeTimeout'))
          }
        } catch (error) {
          console.error('轮询共享数据失败:', error)
          
          if (tries >= maxTries) {
            // 超时处理
            const index = phoneList.value.findIndex(p => p.id === phoneData.id)
            if (index !== -1) {
              const updatedPhone = { ...phoneList.value[index], status: 'timeout', remainingTries: 0 }
              phoneList.value.splice(index, 1, updatedPhone)
            }
            
            clearInterval(timer)
            if (pollingTimers.value[phoneData.id]) {
              clearInterval(pollingTimers.value[phoneData.id])
              delete pollingTimers.value[phoneData.id]
            }
          }
        }
      }, 5000)
      
      // 保存定时器引用
      pollingTimers.value[phoneData.id] = timer
    }
    
    // 结束共享
    const releasePhone = async (phoneId) => {
      releaseLoading.value.add(phoneId)
      
      try {
        const phone = phoneList.value.find(p => p.id === phoneId)
        if (!phone) return
        
        const response = await api.releasePhoneNumber({
          id: phone.taskId,
          phoneNo: phone.phoneNumber,
          channelId: selectedChannel.value?.channelId || '',
          status: 2
        })
        if (response.status === 200) {
          const index = phoneList.value.findIndex(p => p.id === phoneId)
          if (index !== -1) {
            phoneList.value.splice(index, 1)
          }
          
          if (pollingTimers.value[phoneId]) {
            clearInterval(pollingTimers.value[phoneId])
            delete pollingTimers.value[phoneId]
          }
          autoSavedPhoneIds.delete(phoneId)
          
          ElMessage.success($t('messages.releaseSuccess'))
        } else {
          ElMessage.error(response.msg || $t('messages.releaseFailed'))
        }
      } catch (error) {
        console.error('结束共享失败:', error)
        showErrorIfNotNotified(error, $t('messages.releaseFailed'))
      } finally {
        releaseLoading.value.delete(phoneId)
      }
    }
    
    // 屏蔽临时号码
    const addToBlacklist = async (phone) => {
      blacklistLoading.value.add(phone.id)
      
      try {
        const response = await api.blacklistPhone({
          phoneNo: phone.phoneNumber,
          channelId: selectedChannel.value?.channelId || '',
          code: selectedChannel.value?.code || '',
          type: 0
        })
        if (response.status === 200) {
          ElMessage.success($t('messages.blacklistSuccess'))
          
          // 结束该共享
          await releasePhone(phone.id)
        } else {
          ElMessage.error(response.msg || $t('messages.blacklistFailed'))
        }
      } catch (error) {
        console.error('屏蔽临时号码失败:', error)
        showErrorIfNotNotified(error, $t('messages.blacklistFailed'))
      } finally {
        blacklistLoading.value.delete(phone.id)
      }
    }
    
    // 加载缓存的渠道选择（6小时有效期）
    const loadCachedChannelSelection = () => {
      try {
        const cached = localStorage.getItem('channel-selection')
        if (!cached) return false
        
        const data = JSON.parse(cached)
        const now = Date.now()
        const sixHours = 6 * 60 * 60 * 1000 // 6小时的毫秒数
        
        // 检查缓存是否在6小时内
        if (data.timestamp && (now - data.timestamp) < sixHours) {
          if (data.channel && data.project) {
            selectedChannel.value = data.channel
            selectedProject.value = data.project
            // 恢复渠道列表用于快速切换
            if (data.lastChannelList && Array.isArray(data.lastChannelList)) {
              lastChannelList.value = data.lastChannelList
            }
            return true
          }
        } else {
          // 缓存过期，清除
          localStorage.removeItem('channel-selection')
        }
      } catch (e) {
        console.error('Failed to load cached channel selection:', e)
        localStorage.removeItem('channel-selection')
      }
      return false
    }

    // 结束所有共享
    const releaseAllPhones = async () => {
      if (phoneList.value.length === 0) {
        ElMessage.info($t('messages.noPhonesToRelease'))
        return
      }
      
      const promises = phoneList.value.map(phone => releasePhone(phone.id))
      
      try {
        await Promise.all(promises)
        
        // 清空所有轮询
        Object.keys(pollingTimers.value).forEach(phoneId => {
          clearInterval(pollingTimers.value[phoneId])
        })
        pollingTimers.value = {}
        
        // 清空列表
        phoneList.value = []
        autoSavedPhoneIds.clear()
        
        ElMessage.success($t('messages.releaseAllSuccess'))
      } catch (error) {
        console.error('结束所有共享失败:', error)
        showErrorIfNotNotified(error, $t('messages.releaseAllFailed'))
      }
    }
    
    // 复制所有临时号码
    const copyAllPhoneNumbers = async () => {
      if (phoneList.value.length === 0) {
        ElMessage.info($t('messages.noPhonesToCopy'))
        return
      }
      
      const numbers = phoneList.value.map(p => p.phoneNumber).join('\n')
      
      try {
        await navigator.clipboard.writeText(numbers)
        ElMessage.success($t('messages.copySuccess'))
      } catch (err) {
        ElMessage.error($t('messages.copyError'))
      }
    }
    
    // 复制API参数
    const copyApiParams = async () => {
      if (!selectedChannel.value) {
        ElMessage.warning($t('messages.selectChannelFirst'))
        return
      }
      
      const params = {
        sid: selectedProject.value.sid,
        channelId: selectedChannel.value.channelId || '',
        code: selectedChannel.value.code
      }
      
      try {
        await navigator.clipboard.writeText(JSON.stringify(params, null, 2))
        ElMessage.success($t('messages.copySuccess'))
      } catch (err) {
        ElMessage.error($t('messages.copyError'))
      }
    }
    
    // 充值类型切换
    const handleRechargeTypeChange = (type) => {
      rechargeType.value = type
      if (type !== 'usdt') {
        stopAutoCheck()
      }
    }
    
    // 卡密充值
    const handleCardActivation = async (cardNum) => {
      cardActivationLoading.value = true
      
      try {
        const response = await api.activateCard(cardNum)
        if (response.code === 200) {
          ElMessage.success($t('messages.rechargeSuccess'))
          showRechargeDialog.value = false
          fetchUserBalance()
          cardNumber.value = ''
        } else {
          ElMessage.error(response.msg || $t('messages.rechargeFailed'))
        }
      } catch (error) {
        console.error('充值失败:', error)
        showErrorIfNotNotified(error, $t('messages.rechargeFailed'))
      } finally {
        cardActivationLoading.value = false
      }
    }
    
    // 计算USDT充值金额
    const handleCalcPrice = async (amount) => {
      // 更新本地的usdtAmount值
      usdtAmount.value = amount

      if (!amount) {
        transactionInfo.value = {
          address: '',
          price: null,
          usdtMoney: null,
          id: null
        }
        stopAutoCheck() // 清空时停止自动检测
        // 重置loading状态
        if (rechargeDialogRef.value) {
          rechargeDialogRef.value.resetCustomAmountLoading()
        }
        return
      }

      try {
        // 首先获取USDT充值信息（地址和汇率）
        const infoResponse = await api.getUsdtQuotedPrice()
        if ((infoResponse.code === 200 || infoResponse.status === 200 || infoResponse.success) && infoResponse.data) {
          const { address, price: currentRate } = infoResponse.data

          // 然后计算价格 - API expects rechargeMoney as the parameter
          const calcResponse = await api.calcUsdtPrice(Number(amount))
          if ((calcResponse.code === 200 || calcResponse.status === 200 || calcResponse.success) && calcResponse.data) {
            transactionInfo.value = {
              address: address,
              price: currentRate || calcResponse.data.price || calcResponse.data.money,
              usdtMoney: calcResponse.data.usdtMoney || calcResponse.data.usdt,
              id: calcResponse.data.id
            }

            // 开始自动检测充值状态
            startAutoCheck()
          } else {
            ElMessage.error(calcResponse.msg || $t('messages.calcPriceFailed'))
          }
        } else {
          ElMessage.error(infoResponse.msg || $t('messages.usdtInfoFetchFailed'))
        }
      } catch (error) {
        console.error('计算价格失败:', error)
        showErrorIfNotNotified(error, $t('messages.calcPriceFailed'))
      } finally {
        // 无论成功或失败,都重置loading状态
        if (rechargeDialogRef.value) {
          rechargeDialogRef.value.resetCustomAmountLoading()
        }
      }
    }
    
    // 检查充值状态
    const checkRechargeStatus = async () => {
      if (!transactionInfo.value.id) return
      
      try {
        const response = await api.checkUsdtRecharge(transactionInfo.value.id)
        
        // 获取当前时间
        const now = new Date()
        const timeStr = now.toLocaleTimeString('zh-CN')
        
        if (response.status === 200 && response.data) {
          // 检查充值是否成功
          if (response.data.success) {
            // 充值成功
            rechargeLog.value += `\n[${timeStr}] 充值检查：充值成功！金额 ${transactionInfo.value.usdtMoney} USDT 已到账`
            
            ElMessage.success($t('messages.rechargeSuccess'))
            
            // 停止自动检测
            stopAutoCheck()
            
            // 刷新用户余额
            await fetchUserBalance()
            
            // 清空充值数据
            setTimeout(() => {
              transactionInfo.value = {
                address: '',
                price: null,
                usdtMoney: null,
                id: null
              }
              usdtAmount.value = ''
              rechargeLog.value = ''
            }, 3000)
          } else {
            // 充值未到账，继续检测
            if (rechargeLog.value.includes('充值检查：未检测到充值到账')) {
              // 如果已经有未检测到的日志，替换最后一条
              rechargeLog.value = rechargeLog.value.replace(/\n\[\d{2}:\d{2}:\d{2}\] 充值检查：未检测到充值到账.*/, 
                `\n[${timeStr}] 充值检查：未检测到充值到账，请确认已完成转账，系统将继续自动检测`)
            } else {
              // 第一次未检测到
              rechargeLog.value += `\n[${timeStr}] 充值检查：未检测到充值到账，请确认已完成转账，系统将继续自动检测`
            }
          }
        } else {
          // API返回错误
          rechargeLog.value += `\n[${timeStr}] 充值检查：检查失败 - ${response.msg || '未知错误'}`
          console.error('充值检查API返回错误:', response)
        }
      } catch (error) {
        // 网络或其他错误
        const now = new Date()
        const timeStr = now.toLocaleTimeString('zh-CN')
        rechargeLog.value += `\n[${timeStr}] 充值检查：网络错误，将继续尝试...`
        console.error('检查充值状态失败:', error)
      }
    }
    
    // 开始自动检测充值状态
    const startAutoCheck = () => {
      if (checkingRecharge.value) return
      
      checkingRecharge.value = true
      
      // 获取当前时间
      const now = new Date()
      const timeStr = now.toLocaleTimeString('zh-CN')
      
      rechargeLog.value = `[${timeStr}] 交易创建成功，交易ID: ${transactionInfo.value.id}`
      rechargeLog.value += `\n[${timeStr}] 请向地址 ${transactionInfo.value.address} 转账 ${transactionInfo.value.usdtMoney} USDT`
      rechargeLog.value += `\n[${timeStr}] 系统已开始自动检测充值状态，每5秒检测一次...`
      
      // 立即检测一次
      checkRechargeStatus()
      
      // 每5秒检测一次
      autoCheckTimer.value = setInterval(() => {
        checkRechargeStatus()
      }, 5000)
    }
    
    // 停止自动检测
    const stopAutoCheck = () => {
      if (autoCheckTimer.value) {
        clearInterval(autoCheckTimer.value)
        autoCheckTimer.value = null
      }
      checkingRecharge.value = false
    }
    
    // 播放提示音
    const playNotificationSound = () => {
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBi+Gy/DaizsIG2m98LRVVV')
      audio.play().catch(e => console.log('播放提示音失败:', e))
    }
    
    // 跳转到国际项目
    const goToInternationalProjects = () => {
      router.push('/international-projects')
    }

    // 处理教程启动
    const handleStartTutorial = (tutorialType) => {
      if (tutorialType === TUTORIAL_TYPES.RECEIVE_CODE) {
        tutorial.startTutorial()
      } else if (tutorialType === TUTORIAL_TYPES.RECHARGE) {
        // 打开充值对话框并启动充值教程
        showRechargeDialog.value = true
        // TODO: 如果需要充值教程，需要在RechargeDialog中实现
      }
    }
    
    // 打开申请项目弹窗
    const openApplyProjectForm = () => {
      showApplyProjectDialog.value = true
      applyProjectForm.value.content = ''
    }
    
    // 提交申请项目
    const submitApplyProject = async () => {
      if (!applyProjectForm.value.content.trim()) {
        ElMessage.warning($t('projectApplication.contentRequired'))
        return
      }
      
      if (applyProjectForm.value.content.length < 2) {
        ElMessage.warning($t('projectApplication.contentLengthError'))
        return
      }
      
      applyProjectLoading.value = true
      
      try {
        const response = await api.applyProject({
          content: applyProjectForm.value.content
        })
        if (response.code === 200) {
          ElMessage.success($t('messages.applySuccess'))
          showApplyProjectDialog.value = false
          applyProjectForm.value.content = ''
        } else {
          ElMessage.error(response.msg || $t('messages.applyFailed'))
        }
      } catch (error) {
        console.error('申请项目失败:', error)
        showErrorIfNotNotified(error, $t('messages.applyFailed'))
      } finally {
        applyProjectLoading.value = false
      }
    }
    
    // 获取并显示公告
    const fetchAndShowNotice = async () => {
      try {
        const response = await api.getLatestNotice()
        if (response.code === 200 && response.data) {
          // 检查是否需要显示公告
          const lastNoticeTime = localStorage.getItem('last-notice-time')
          const currentTime = new Date().getTime()
          const oneHour = 60 * 60 * 1000
          
          if (!lastNoticeTime || (currentTime - parseInt(lastNoticeTime)) > oneHour) {
            noticeContent.value = response.data.content
            showNoticeDialog.value = true
            noticeCountdown.value = 10
            
            // 开始倒计时
            noticeTimer.value = setInterval(() => {
              noticeCountdown.value--
              if (noticeCountdown.value <= 0) {
                closeNoticeDialog()
              }
            }, 1000)
            
            // 记录本次显示公告的时间
            localStorage.setItem('last-notice-time', currentTime.toString())
          }
        }
      } catch (error) {
        console.error('获取公告失败:', error)
      }
    }
    
    // 关闭公告弹窗
    const closeNoticeDialog = () => {
      showNoticeDialog.value = false
      
      if (noticeTimer.value) {
        clearInterval(noticeTimer.value)
        noticeTimer.value = null
      }
      
      // 记录关闭公告的时间
      localStorage.setItem('last-notice-time', new Date().getTime().toString())
    }
    
    // 存储滚动位置
    let scrollPosition = 0
    
    // 禁用/恢复页面滚动的通用函数
    const togglePageScroll = (disable) => {
      if (disable) {
        // 保存当前滚动位置
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop
        // 禁用body和html的滚动
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
        document.body.style.top = `-${scrollPosition}px`
        document.body.style.width = '100%'
        document.documentElement.style.overflow = 'hidden'
      } else {
        // 恢复滚动
        document.body.style.overflow = ''
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.width = ''
        document.documentElement.style.overflow = ''
        // 恢复之前的滚动位置
        window.scrollTo(0, scrollPosition)
      }
    }
    
    // 监听充值对话框关闭
    watch(showRechargeDialog, (newVal) => {
      if (!newVal) {
        stopAutoCheck()
      }
    })
    
    // 监听所有对话框状态，统一处理滚动禁用
    watch(isAnyDialogOpen, (newVal) => {
      togglePageScroll(newVal)
    })

    // 页面刷新拦截处理函数
    const handleBeforeUnload = (e) => {
      // 检查是否有正在接收的临时号码
      if (phoneList.value && phoneList.value.length > 0) {
        const message = '您有正在接收数据的临时号码,刷新后会消失,确定要刷新吗?'
        e.preventDefault()
        e.returnValue = message // 标准写法
        return message // 兼容某些浏览器
      }
    }

    // 组件挂载时
    onMounted(() => {
      // 添加窗口大小变化监听
      window.addEventListener('resize', handleResize)

      // 添加页面刷新拦截
      window.addEventListener('beforeunload', handleBeforeUnload)

      if (checkAuth()) {
        fetchUserBalance()
        fetchSuccessRate()
        fetchAndShowNotice()

        // 加载缓存的渠道选择（6小时有效期）
        loadCachedChannelSelection()

        // 加载进行中的任务（只在页面加载时调用一次）
        loadExistingTasks()

        // 处理从国际项目页面跳转过来的情况
        const projectName = route.query.projectName

        if (projectName) {
          // 延迟执行,确保页面已经完全渲染
          setTimeout(() => {
            // 设置搜索关键词为项目名称
            searchKeyword.value = projectName
            // 自动触发项目搜索
            searchProjects(true)

            // 清除URL中的projectName参数,避免刷新页面时重复搜索
            router.replace({
              name: 'ReceiveCode',
              query: {}
            })
          }, 500)
        }
      }

      // 首次访问时自动启动教程（但如果是从国际项目跳转过来的，则不自动启动教程）
      if (!tutorial.isCompleted.value && !isMobile.value && !route.query.projectName) {
        setTimeout(() => {
          tutorial.startTutorial()
        }, 1500) // 延迟1.5秒，等待页面完全渲染
      }
    })
    
    // 组件卸载时
    onUnmounted(() => {
      // 移除窗口大小变化监听
      window.removeEventListener('resize', handleResize)
      clearTimeout(resizeTimer)

      // 移除页面刷新拦截
      window.removeEventListener('beforeunload', handleBeforeUnload)

      // 清理所有轮询
      Object.keys(pollingTimers.value).forEach(phoneId => {
        clearInterval(pollingTimers.value[phoneId])
      })

      // 停止自动检测
      stopAutoCheck()

      // 清理公告定时器
      if (noticeTimer.value) {
        clearInterval(noticeTimer.value)
      }

      // 确保恢复页面滚动
      togglePageScroll(false)
    })
    
    return {
      // 教程
      tutorial,

      // 状态
      isMobile,
      isAnyDialogOpen,
      userBalance,
      successRateData,
      searchKeyword,
      selectedProject,
      selectedChannel,
      phoneList,
      gettingPhone,
      enableAudio,
      autoSaveData,
      
      // 弹窗状态
      showRechargeDialog,
      rechargeDialogRef,
      showProjectDialog,
      showChannelDialog,
      showAdvancedOptions,
      showQuickChannelSelect,
      showNoticeDialog,
      showApplyProjectDialog,
      showTutorialMenu,
      
      // 充值相关
      rechargeType,
      cardNumber,
      usdtAmount,
      cardActivationLoading,
      transactionInfo,
      rechargeLog,
      
      // 项目和渠道
      projectResults,
      channelList,
      lastChannelList,
      searchLoading,
      channelLoading,
      channelSelectLoading,
      hasSearched,
      
      // 高级选项
      advancedOptions,
      
      // 加载状态
      releaseLoading,
      blacklistLoading,
      
      // 公告
      noticeContent,
      noticeCountdown,
      
      // 申请项目
      applyProjectForm,
      applyProjectLoading,
      
      // 方法
      searchProjects,
      openProjectSearch,
      handleProjectSelect,
      showChannels,
      selectChannel,
      selectQuickChannel,
      openQuickChannelSelect,
      handleCountryChange,
      getPhoneNumber,
      releasePhone,
      addToBlacklist,
      releaseAllPhones,
      copyAllPhoneNumbers,
      copyApiParams,
      handleRechargeTypeChange,
      handleCardActivation,
      handleCalcPrice,
      goToInternationalProjects,
      handleStartTutorial,
      openApplyProjectForm,
      submitApplyProject,
      closeNoticeDialog,
      hasActivity,
      getDisplayPrice,
      getOriginalPrice,
      getActivityName
    }
  }
}
</script>

<style>
@import '@/assets/styles/receive-code.css';
</style>
